<script lang="ts">
  import { getHref } from '../../helpers/sections-helper';
  import BulletPoint from '../../components/BulletPoint.svelte';
  import './css/services1.scss';
  import type { Services } from '../types';

  export let properties: Services;

  $: ({ headline, items, button, callouts } = properties);
</script>

<section class="some-of-services">
  <div class="wrapper">
    <div class="why-top">
      <h2 class="h2">{@html headline.value}</h2>
      <div class="my-6 h-[1px] w-[100px] bg-[var(--color-accent)]"></div>
    </div>

    <div class="grid w-full grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
      {#each items as { description, image, title }, index}
        <div class="why-us-card">
          <div
            class="flex flex-col items-center justify-center gap-4 text-center md:flex-row md:items-start md:text-left"
          >
            {#if image}
              <img
                loading="lazy"
                src={image.value}
                alt="img"
                class="object-fit aspect-square h-[45px] w-[45px]"
              />
            {/if}
            <div class="flex flex-1 flex-col gap-2">
              <h3 class="h3">{@html title.value}</h3>
              <p class="text opacity-75">
                {@html description.value}
              </p>
            </div>
          </div>
        </div>
      {/each}
    </div>

    <div class="mx-auto mt-16">
      {#if button && button?.label?.length}
        <div class="bottom-boxes">
          <a
            class="primary-button open-form-js"
            target={button.link_type === 'External' ? '_blank' : ''}
            href={getHref(button.link_type, button.link)}
            >{@html button.label}</a
          >
          {#if callouts}
            <div class="small-text-box">
              {#each callouts.value as item}
                <div>
                  <BulletPoint bulletIcon={callouts.icon} />
                  <p class="text-small">{@html item}</p>
                </div>
              {/each}
            </div>
          {/if}
        </div>
      {/if}
    </div>
  </div>
</section>
